import SubscriptionSuccess from "../../components/subscription/SubscriptionSuccess.tsx";

function SubscriptionSuccessPage() {
  return <SubscriptionSuccess />;
}

export default SubscriptionSuccessPage;
